import { CubeProject } from '@dc-shared-web/lib'
import { AxiosInstance } from 'axios'

export const fetchProjects = async (
  apiClient: AxiosInstance,
  params: {
    currentTeamUuid: string
    currentTable: string
    page: 'folder' | 'dashboard'
    folderId?: number
  }
) => {
  const { data: axiosData } = await apiClient.get<{ data: CubeProject[] }>(
    '/ajax/cube/projects',
    {
      params,
    }
  )
  return axiosData.data
}
